import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect } from "react";
import { DataTable, Grid, Paper, numeral, setLocale, makeStyles, Typography } from "../../../../";
var useStyles = makeStyles(function (theme) {
  return {
    header: {
      "justify-content": "space-between"
    },
    card: {
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    content: {
      width: "40%",
      "text-align": "center",
      margin: "20px"
    },
    cardText: {
      background: "#b7b6b682",
      width: "100%",
      minHeight: "200px",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      borderRadius: "0 4px 4px 0"
    }
  };
});

var ProjectDashboard = function ProjectDashboard(_ref) {
  var data = _ref.data,
      options = _ref.options,
      language = _ref.language,
      translation = _ref.translation,
      tasks = _ref.tasks,
      locale = _ref.locale,
      props = _objectWithoutProperties(_ref, ["data", "options", "language", "translation", "tasks", "locale"]);

  var classes = useStyles();
  useEffect(function () {
    setLocale(locale);
  }, [locale]);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      marginTop: "64px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_tasks",
    type: "tasks",
    options: options,
    data: tasks,
    translation: translation ? translation.datatables.tasks : null
  })));
};

export default ProjectDashboard;